/* Kaufblock im Produktkopf (sections/mus-pdp-main). Dawn-Stil: ein Custom Element,
   kein Framework. Aufgaben:
   - aus den Auswahlfeldern (Farbe, Paket) die Variante bestimmen und das
     versteckte Feld name="id" nachführen,
   - Preis der Auswahl (Paketpreis mal Anzahl), Beschreibung und Stückpreis
     aktualisieren, Paketnamen im Auswahlfeld mit Preis beschriften,
   - Bild der Galerie auf das Variantenbild umschalten,
   - nicht verfügbare Variante: Button gesperrt mit Text „Nicht verfügbar",
   - Pflichtbestätigung zu den Druckdaten vor dem Absenden prüfen (das Formular
     trägt novalidate, product-form.js sendet per fetch),
   - ?variant= in der Adresse nachführen.
   Der Zakeke-Button schickt dasselbe Formular, nimmt also Variante und Anzahl mit.
   Ohne JavaScript bleibt die vorausgewählte Variante bestellbar. */
if (!customElements.get('mus-buybox')) {
  customElements.define('mus-buybox', class MusBuybox extends HTMLElement {
    connectedCallback() {
      this.form = this.querySelector('form');
      const json = this.querySelector('[data-variants]');
      if (!this.form || !json) return;
      try {
        this.variants = JSON.parse(json.textContent);
      } catch (error) {
        this.variants = [];
      }
      if (!Array.isArray(this.variants) || !this.variants.length) return;

      this.packageIndex = Number(this.dataset.packageOption);
      if (!Number.isFinite(this.packageIndex)) this.packageIndex = -1;
      this.names = this.parseNames(this.dataset.packageNames || '');
      this.noteTemplate = this.dataset.noteTemplate || '';
      this.unavailableLabel = this.dataset.unavailableLabel || 'Nicht verfügbar';
      this.currency = new Intl.NumberFormat('de-DE', { style: 'currency', currency: this.dataset.currency || 'EUR' });

      this.selects = Array.prototype.slice.call(this.querySelectorAll('select[data-option-index]'));
      this.packageSelect = this.selects.find((s) => Number(s.dataset.optionIndex) === this.packageIndex) || null;
      this.idInput = this.form.querySelector('[data-buybox-id]');
      this.quantity = this.querySelector('[data-buybox-quantity]');
      this.total = this.querySelector('[data-buybox-total]');
      this.meta = this.querySelector('[data-buybox-meta]');
      this.note = this.querySelector('[data-buybox-note]');
      this.submitButton = this.querySelector('[data-buybox-submit]');
      this.submitLabel = this.querySelector('[data-buybox-submit-label]');
      this.addLabel = this.submitButton ? (this.submitButton.dataset.addLabel || 'In den Warenkorb') : '';
      this.rights = this.querySelector('[data-buybox-rights]');
      this.rightsError = this.querySelector('[data-buybox-rights-error]');

      this.onChange = this.onChange.bind(this);
      this.onSubmitCapture = this.onSubmitCapture.bind(this);
      this.addEventListener('change', this.onChange);
      // Capture-Phase am Vorfahren: läuft vor dem submit-Handler von product-form.js.
      this.addEventListener('submit', this.onSubmitCapture, true);
      if (this.quantity) this.quantity.addEventListener('input', () => this.update());

      this.update();
    }

    disconnectedCallback() {
      this.removeEventListener('change', this.onChange);
      this.removeEventListener('submit', this.onSubmitCapture, true);
    }

    /* „6=Business Test" je Zeile -> { 6: 'Business Test' } */
    parseNames(text) {
      const names = {};
      text.split(/\r?\n/).forEach((line) => {
        const parts = line.split('=');
        if (parts.length < 2) return;
        const key = parseInt(parts[0].trim(), 10);
        const name = parts.slice(1).join('=').trim();
        if (Number.isFinite(key) && name) names[key] = name;
      });
      return names;
    }

    onChange(event) {
      const target = event.target;
      if (target instanceof HTMLSelectElement && target.dataset.optionIndex !== undefined) {
        this.update();
        this.updateUrl();
        return;
      }
      if (target === this.quantity) {
        this.update();
        return;
      }
      if (target === this.rights && this.rightsError) {
        this.rightsError.hidden = true;
      }
    }

    onSubmitCapture(event) {
      if (!this.rights || this.rights.checked) {
        if (this.rightsError) this.rightsError.hidden = true;
        return;
      }
      event.preventDefault();
      event.stopImmediatePropagation();
      if (this.rightsError) this.rightsError.hidden = false;
      this.rights.focus();
    }

    /* Stückzahl aus dem Optionswert: „24 Stück" -> 24 */
    stueckFor(value) {
      const number = parseInt(String(value || '').split(' ')[0], 10);
      return Number.isFinite(number) && number > 0 ? number : 0;
    }

    money(cents) {
      return this.currency.format(cents / 100);
    }

    selectedOptions() {
      const options = [];
      this.selects.forEach((select) => {
        options[Number(select.dataset.optionIndex)] = select.value;
      });
      return options;
    }

    findVariant(options) {
      return this.variants.find((variant) => variant.options.every((value, index) => options[index] === undefined || options[index] === value)) || null;
    }

    currentQuantity() {
      if (!this.quantity) return 1;
      const value = parseInt(this.quantity.value, 10);
      return Number.isFinite(value) && value > 0 ? value : 1;
    }

    /* Paketfeld: „Growth · 24 Stück · 141,60 €" für die gerade gewählten übrigen Optionen. */
    updatePackageLabels(options) {
      if (!this.packageSelect) return;
      Array.prototype.forEach.call(this.packageSelect.options, (option) => {
        const test = options.slice();
        test[this.packageIndex] = option.value;
        const variant = this.findVariant(test);
        const stueck = this.stueckFor(option.value);
        const parts = [];
        if (this.names[stueck]) parts.push(this.names[stueck]);
        parts.push(option.value);
        if (variant) parts.push(this.money(variant.price));
        option.textContent = parts.join(' · ');
      });
    }

    /* Galerie auf das Variantenbild: das Vorschaubild mit demselben Dateipfad anklicken. */
    showVariantImage(variant) {
      if (!variant || !variant.featured_image || !variant.featured_image.src) return;
      const path = String(variant.featured_image.src).split('?')[0].replace(/^https?:/, '');
      const thumb = Array.prototype.find.call(document.querySelectorAll('[data-gallery-thumb]'), (element) => {
        const src = String(element.dataset.src || '').split('?')[0].replace(/^https?:/, '');
        return src === path;
      });
      if (thumb && thumb.getAttribute('aria-current') !== 'true') thumb.click();
    }

    update() {
      const options = this.selectedOptions();
      this.updatePackageLabels(options);

      const variant = this.findVariant(options);
      const quantity = this.currentQuantity();
      const stueck = this.packageIndex === -1 ? 0 : this.stueckFor(options[this.packageIndex]);
      const available = !!(variant && variant.available);

      if (this.idInput && variant) this.idInput.value = String(variant.id);

      if (this.submitButton) {
        this.submitButton.disabled = !available;
        if (this.submitLabel) this.submitLabel.textContent = available ? this.addLabel : this.unavailableLabel;
      }

      if (this.total) this.total.textContent = variant ? this.money(variant.price * quantity) : '';

      if (this.meta) {
        const parts = [];
        if (stueck && this.names[stueck]) parts.push(this.names[stueck]);
        if (stueck) parts.push(stueck + ' Stück');
        options.forEach((value, index) => {
          if (index !== this.packageIndex && value) parts.push(value);
        });
        if (!stueck && variant) parts.push(variant.title);
        if (quantity > 1) parts.push(quantity + ' Pakete');
        if (!available) parts.push(this.unavailableLabel);
        this.meta.textContent = parts.join(', ');
      }

      if (this.note) {
        let text = '';
        if (variant && stueck) {
          text = this.money(Math.round(variant.price / stueck)) + ' pro Stück, ' + (stueck * quantity) + ' Tassen. ';
        }
        this.note.textContent = text + this.noteTemplate;
      }

      this.showVariantImage(variant);
      this.updateTierList(options);
    }

    /* Paketübersicht darunter (sections/mus-variant-tiers, Erklärmodus, data-tier-static):
       Stückpreis, Paketpreis und Ersparnis für die gerade gewählte Farbe, gerechnet wie
       im Liquid (Stückpreis in Cent kaufmännisch gerundet, Ersparnis abgerundet). Nötig,
       seit Weiß eigene Preise hat (02.10.2026); gerundet seit 05.10.2026 (6er 49,90 €).
       Basis der Ersparnis: (Preis des kleinsten Pakets minus Versandanteil aus
       data-tier-shipping, Cent) geteilt durch Stückzahl; das kleinste Paket selbst
       zeigt nie eine Ersparnis (05.10.2026). */
    updateTierList(options) {
      if (this.packageIndex === -1) return;
      const lists = document.querySelectorAll('[data-tier-static]');
      if (!lists.length) return;
      const rowsFor = (list) => Array.prototype.map.call(list.querySelectorAll('[data-tier-value]'), (row) => {
        const test = options.slice();
        test[this.packageIndex] = row.dataset.tierValue;
        const variant = this.findVariant(test);
        const stueck = this.stueckFor(row.dataset.tierValue);
        const unit = variant && stueck ? Math.round(variant.price / stueck) : 0;
        return { row, variant, stueck, unit };
      });
      Array.prototype.forEach.call(lists, (list) => {
        const rows = rowsFor(list);
        const ship = Number(list.dataset.tierShipping) || 0;
        let basePrice = 0;
        let baseStueck = 0;
        rows.forEach((r) => {
          if (r.variant && r.stueck > 0 && (baseStueck === 0 || r.stueck < baseStueck)) {
            baseStueck = r.stueck;
            basePrice = r.variant.price;
          }
        });
        const baseNet = basePrice - ship > 0 ? basePrice - ship : basePrice;
        const baseUnit = baseStueck > 0 ? baseNet / baseStueck : 0;
        rows.forEach((r) => {
          const unitEl = r.row.querySelector('[data-tier-unit]');
          const totalEl = r.row.querySelector('[data-tier-total]');
          const savingEl = r.row.querySelector('[data-tier-saving]');
          if (unitEl) unitEl.textContent = r.unit > 0 ? this.money(r.unit) : '';
          if (totalEl) totalEl.textContent = r.variant ? this.money(r.variant.price) : '';
          if (savingEl) {
            const saving = baseUnit > 0 && r.unit > 0 && r.stueck !== baseStueck && r.unit < baseUnit ? Math.floor((baseUnit - r.unit) * 100 / baseUnit) : 0;
            savingEl.innerHTML = saving > 0
              ? '<span class="mus-badge mus-badge--accent">' + saving + ' % günstiger</span>'
              : '<span class="text-small text-muted">Basispreis</span>';
          }
        });
      });
    }

    updateUrl() {
      const variant = this.findVariant(this.selectedOptions());
      if (!variant || !window.history || !window.history.replaceState) return;
      try {
        const url = new URL(window.location.href);
        url.searchParams.set('variant', String(variant.id));
        window.history.replaceState({}, '', url.toString());
      } catch (error) {
        // Adresse bleibt unverändert.
      }
    }
  });
}
